import { useEffect, useState } from "react";

import { Checkbox } from "@fluentui/react-components";

import FormFieldLabel from "components/FormFieldLabel/FormFieldLabel";
import { ErrorMessageContainer, FormFieldContainer, StyledErrorMessage } from "components/styled";

type Props = {
  name: string;
  label: string;
  required?: boolean;
  info?: string;
  size?: "medium" | "large" | undefined;
  value: boolean;
  setFieldValue: (name: string, value: boolean) => void;
  error?: string;
};

const CheckboxField = ({
  name,
  label,
  required = false,
  info,
  size,
  error,
  setFieldValue,
  value,
}: Props) => {
  const [localValue, setLocalValue] = useState(value);

  useEffect(() => {
    setLocalValue(value);
  }, [value]);
  return (
    <FormFieldContainer>
      <Checkbox
        size={size}
        checked={localValue}
        onChange={(ev, data) => {
          setFieldValue(name, data.checked ? true : false);
        }}
        label={<FormFieldLabel info={info} label={label} required={required} />}
      />
      <ErrorMessageContainer>
        <StyledErrorMessage>{error}</StyledErrorMessage>
      </ErrorMessageContainer>
    </FormFieldContainer>
  );
};

export default CheckboxField;
